import { Controller } from "react-hook-form";

import { IconChevronDown } from "@pentabd/icons";
import { InputSelect } from "@pentabd/ui";

import {
  OnChangeType,
  OptionType,
  RenderType,
  SelectionType,
} from "@pentabd/ui/build/atoms/select/types";

interface SelectType {
  register: any;
  name: string;
  control: any;
  setValue: any;
  options: OptionType[];
  placeholder?: string;
  status?: "primary" | "secondary" | "danger" | "warning" | "success" | "info";
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  isMulti?: boolean;
  isSearchable?: boolean;
  isClearable?: boolean;
  onChange?: OnChangeType;
  suffix?: JSX.Element | JSX.Element[] | string;
  prefix?: JSX.Element | JSX.Element[] | string;
  stablePrefix?: boolean;
  stableSuffix?: boolean;
  disabled?: boolean;
  renderSelected?: RenderType;
  value?: string | number | string[];
  defaultValue?: string | number | string[];
  onSelectItem?: (data: SelectionType) => void;
  portal?: boolean;
  minWidth?: boolean;
  emptyMessage?: string;
  error?: any;
  selectAction?: (e: number) => void;
  zIndexValue?: number;
}

export const SelectController = ({
  register,
  name,
  control,
  placeholder,
  disabled,
  options,
  setValue,
  size,
  portal,
  isMulti,
  isClearable,
  isSearchable,
  selectAction,
  error,
  zIndexValue,
}: SelectType) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => {
        return (
          <InputSelect
            {...register}
            defaultValue={field.value as number}
            onSelectItem={(e) => {
              setValue(name, e as number);
              selectAction && selectAction(e as number);
            }}
            suffix={<IconChevronDown size="16" />}
            options={options}
            placeholder={placeholder}
            disabled={disabled}
            size={size}
            portal={portal}
            isMulti={isMulti}
            isClearable={isClearable}
            isSearchable={isSearchable}
            error={error as any}
            zIndexValue={zIndexValue}
          />
        );
      }}
    />
  );
};
